/* Copyright 2020 VMware, Inc. All rights reserved. VMware Confidential */
import { Directive } from "@angular/core";
import { RouterLinkActive } from "@angular/router";

// @formatter:off
@Directive({
    selector: "[dr-set-aria-current]",
    host: { "[attr.aria-current]": 'routerLinkActive.isActive ? "page" : null' }
})
// @formatter:on
export class DrSetAriaCurrentDirective {
    constructor(public routerLinkActive: RouterLinkActive) {
    }
}
